import React from 'react'

import JitsiVideoConference from '../videoConference'

export default () => {
  return <JitsiVideoConference />
}
